/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNorthStar = createReactComponent("north-star", "IconNorthStar", [
  ["path", { d: "M3 12h18", key: "svg-0" }],
  ["path", { d: "M12 21v-18", key: "svg-1" }],
  ["path", { d: "M7.5 7.5l9 9", key: "svg-2" }],
  ["path", { d: "M7.5 16.5l9 -9", key: "svg-3" }]
]);

export { IconNorthStar as default };
//# sourceMappingURL=IconNorthStar.js.map
